export default "__VITE_ASSET__CuF22Jjc__"